export const getIpAddress = async () => {
    try {
        const response = await fetch('https://api.ipify.org?format=json');
        const data = await response.json();
        return data.ip;
    } catch (error) {
        console.error('Error fetching IP:', error);
        return 'unknown';
    }
};

export const logToSplunk = async (eventData) => {
    // Use backend proxy endpoint instead of direct HEC call
    const PROXY_URL = '/api/splunk/log';

    try {
        // Get IP address if not already in eventData
        if (!eventData.ip) {
            eventData.ip = await getIpAddress();
        }

        console.log('Sending data to Splunk via proxy...', {
            type: eventData.type,
            timestamp: new Date().toISOString()
        });

        const response = await fetch(PROXY_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(eventData)
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({ error: 'Unknown error' }));
            throw new Error(`Proxy responded with ${response.status}: ${errorData.error || 'Unknown error'}`);
        }

        const result = await response.json();
        console.log('Data sent to Splunk successfully:', result);

        return result;

    } catch (error) {
        console.error('Error sending data to Splunk:', error);

        // More specific error handling
        if (error.message.includes('Failed to fetch')) {
            console.error('Network Error: Could not reach the backend proxy. Make sure the server is running.');
        }

        throw error; // Re-throw to allow caller to handle if needed
    }
};
